import gql from 'graphql-tag';

const MAKE_SERVICE_DOCKET_NEXT_STOP = gql`
	mutation makeServiceDocketNextStopMutation($serviceRunId: ID!, $serviceDocketId: ID!, $reason: String!, $adminTraining: Boolean) {
		makeServiceDocketNextStop(serviceRunId: $serviceRunId, serviceDocketId: $serviceDocketId, reason: $reason, adminTraining: $adminTraining) {
			id
			machineOrder
			myDayOrderChanges {
				at
				reason
			}
		}
	}
`;

export default MAKE_SERVICE_DOCKET_NEXT_STOP;
